/**
 * Rest methods allowed to
 * use on request
 */
export enum RestMethod {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE,
}
/**
 * Operation for PATCH request
 */
export enum PATCH_OP {
  REPLACE = 'replace',
  ADD = 'add',
  REMOVE = 'remove',
}
